<div class="w-full relative">
  <a [routerLink]="['/portal/', item.id, 'institute']" *ngIf="item && item!=null"
    class="cursor-pointer flex-column sm:flex-row md:flex-column lg:flex-row flex align-items-center gap-3 justify-content-between border-1 border-round-lg p-3 pr-7 border-bluegray-200 bg-white">
    <div class="flex align-items-center gap-3">
      <div class="w-5rem h-5rem overflow-hidden border-circle flex-shrink-0">
        <img [src]="item.logo ? item.logo : '../../../assets/images/logo-placeholder.png'" alt="" class="w-full h-full"
          style="object-fit: cover;">
      </div>
      <div class="flex-1 flex flex-column gap-1">
        <b class="text-left font-medium text-2xl" style="color: #052647;">{{item.instituteName}}</b>
        <p class="text-left font-normal text-base" style="color: #575B68;">
          {{item ? (item.city + ', ' + item.country) : ''}}
        </p>
      </div>
    </div>
    <div class="flex flex-column gap-2 w-full max-w-22rem flex-shrink-0 text-center sm:text-right">
      <!-- Official Application Deadline -->
      <div class="flex flex-column gap-1">
        <b class="font-medium text-2xl" style="color: #052647;">
          {{ daysLeft && daysLeft > 0 ? daysLeft.toString() : '0' }} Days Left
        </b>
        <p class="font-normal text-base" style="color: #515151;">
          Submit before {{item.applicationDeadlineRegularDecision | date: 'dd MMM yyyy'}}
        </p>
      </div>

      <!-- Mentor Deadline — only shown when set -->
      <div *ngIf="mentorDeadline" class="mentor-deadline-row mt-1 py-1 px-2 border-round-md" style="background-color: #F0EEFF;">
        <span class="text-sm font-semibold" style="color: #5B4BD9;">
          {{ mentorDeadlineLabel || 'Mentor Deadline' }}: {{mentorDeadline | date: 'dd MMM yyyy'}} — 
          {{ mentorDaysLeft !== null && mentorDaysLeft > 0 ? mentorDaysLeft.toString() : '0' }} days left
        </span>
      </div>
    </div>
  </a>
  <div *ngIf="item && item!=null" class="flex gap-2" style="position: absolute; right: 8px; top: 8px; z-index: 99;">
    <p-button icon="pi pi-trash" tooltipPosition="bottom" pTooltip="Remove College" styleClass="trash"
      (onClick)="toggleMyInstitute(item.id)" class="trashw" />
  </div>
</div>